import React, { Component } from "react";

export default class WorkspaceCardErrors extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    componentDidCatch(error, info) {
      this.setState({ hasError: true });
    }
  
    render() {
        let cardStyle = {
			top: this.props.y * 19.5 + "rem",
			left: `calc((100% - ${(this.props.columns - 1) * 2.5}rem) / ${this.props.columns} * ${this.props.x} + ${this.props.x * 2.5}rem)`,
			width: `calc((100% - ${(this.props.columns - 1) * 2.5}rem) / ${this.props.columns} * ${this.props.width} + ${(this.props.width - 1) * 2.5}rem)`,
			height: 17 + (this.props.height - 1) * 19.5 + "rem",
            display:'flex',
            flexDirection:'column',
            justifyContent:'center',
            alignItems:'center'
		};

      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
        <div style = {cardStyle} className="visualization-card-outer">
            <div style={{fontSize:"5rem"}} class="material-icons">error_outline</div>
            <div style={{fontSize:"1rem"}}>There was an error while loading this item.</div>
        </div>
        ) //
      }
      return this.props.children;
    }
  }